import React from '@root/vendor/react';

const AnalyticsContext = React.createContext({});

export default AnalyticsContext;
